import React from 'react';

interface LabelButtonProps {
  label: string;
  onClick: () => void;
  href?: string;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
}

const LabelButton: React.FC<LabelButtonProps> = ({ label, onClick, href = '#', style, className, disabled = false }) => {
  return (
    <a
      href={href}
      onClick={(e) => {
        e.preventDefault(); // Prevent default anchor behavior
        if (!disabled) {
          onClick(); // Call onClick only if not disabled
        }
      }}
      style={{
        ...style,
        color: disabled ? 'gray' : 'blue',
        textDecoration: disabled ? 'none' : 'underline',
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      className={className}
      aria-disabled={disabled} // Add accessibility support for disabled state
    >
      {label}
    </a>
  );
};

export default LabelButton;
